// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__lcITA","bold":"styles_bold__P3Dad","link":"styles_link__s7cgu"};